import { useRef, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { DetailView } from './detail-view';
import { DetailPhone } from './detail-phone';
import { CourseView } from './course-view';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import accountForms from 'src/api/accounts/vm-form';
import studentForms from 'src/api/students/vm-form';
import useToast from 'src/utils/toast-utils';
import { useCallbackAction } from 'src/hooks/use-actions';
import PageSection from 'src/layouts/page-section';
import { useRouter } from 'src/hooks/use-router';
import { nextNavigate } from 'src/utils/navigation-utils';
import { paths } from 'src/paths';
import useDeviceView from 'src/hooks/use-device-view';

const Page = ({ onNavigate, item, toPage }) => {
  // console.log('========== ITEM', item);
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const childRef = useRef();
  const router = useRouter();
  const { isPhone, useCompactLayout } = useDeviceView();

  const { blockAccount, changeAccountNote } = accountForms();
  const {  updateStudent } = studentForms();
  const { toastSuccess, toastError, toastMessage } = useToast();

  const apiUpdateNote = (values) => useCallbackAction(changeAccountNote, values, (result) => {
    toastSuccess(`Ghi chú đã được cập nhật`);
  }, toastError);

  const apiRemove = (values) => useCallbackAction(blockAccount, values, 
                                  (result) => {
                                    toastSuccess(`Đã khóa ${item.code}`, {action: 'back'}); 
                                  }, toastError);

  const apiUpdateCourse = (values) => useCallbackAction(updateStudent, values, 
    (result) => {
      childRef.current?.setDataFromParent(result); 
    }, toastError);

  const handleTracking = (item) => {
    // console.log('====', item);
    nextNavigate(
      router,
      { id: item.id, code: item.code },
      paths.tracking.items,
      paths.students.details,
      { id: item.id, code: item.code, name: item.name, birthday: item.birthday },
    );
  };

   const handleGroup = (item) => {
    toastMessage('Đang xây dựng');
    // console.log('====', item);
    // nextNavigate(
    //   router,
    //   { id: item.id, code: item.code },
    //   paths.tracking.items,
    //   paths.students.details,
    //   { id: item.id, code: item.code, name: item.name, birthday: item.birthday },
    // );
  };

  return (
    <PageSection title="Student" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.students)}
          subLabel={item.code}
        />
        {toPage === 'course' ? (
          <CourseView
            ref={childRef}
            item={item}
            apiUpdateCourse={apiUpdateCourse}
          /> 
        ) : useCompactLayout ? (
          <DetailPhone
            ref={childRef}
            item={item}
            onTrackingClicked={handleTracking}
            onGroupClicked={handleGroup}
          />
        ) : (
          <DetailView
            ref={childRef}
            item={item}
            apiChangeNote={apiUpdateNote}
            onTrackingClicked={handleTracking}
            onGroupClicked={handleGroup}
          />
        )}
      </Stack>
    </PageSection>
  );
};

export default Page;
